import { Injectable } from '@angular/core'
import { RoutingService, WindowRef } from '@spartacus/core'
import { CookieService } from 'ngx-cookie-service'
import { Observable } from 'rxjs'
import { take } from 'rxjs/operators'
import { EbAuthService } from '../../../auth/services/eb-auth.service'
import { EbProductDetailAdapter } from '../connectors/eb-product-detail.adapter'
import { EbProductService } from './eb-product.service'

@Injectable({
  providedIn: 'root'
})
export class EbProductDetailService {
  constructor(protected productDetailAdapter: EbProductDetailAdapter) {}

  static checkForEncryptedArticleNumber(
    authService: EbAuthService,
    winRef: WindowRef,
    productService: EbProductService,
    routingService: RoutingService
  ) {
    return () => {
      const urlMatch = winRef.location.pathname.match(/v\/([\w\-]+)/)
      const variantCode = urlMatch?.[1]
      if (variantCode) {
        const isEncryptedCode = /^_/.test(variantCode)
        if (isEncryptedCode) {
          productService
            .decryptVariantCode(variantCode)
            .pipe(take(1))
            .subscribe(decrypted => {
              routingService.go('/v/' + decrypted)
            })
        }
      }
    }
  }

  sendRequestForQuotation(variantId: string): Observable<any> {
    return this.productDetailAdapter.sendRequestForQuotation(variantId)
  }
}
